"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductDetails = ProductDetails;
exports.ProductFooter = ProductFooter;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _coinDollar = _interopRequireDefault(require("cccisd-icons/coin-dollar"));
var _cart = _interopRequireDefault(require("cccisd-icons/cart"));
var _enter = _interopRequireDefault(require("cccisd-icons/enter"));
var _newTab = _interopRequireDefault(require("cccisd-icons/new-tab"));
var _ShareButton = _interopRequireDefault(require("../ResourceLists/ShareButton"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ProductDetails(_ref) {
  var resource = _ref.resource,
    displayOptions = _ref.displayOptions;
  var metadata = JSON.parse(resource.published_metadata) || {};
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].productDescriptors,
    style: {
      color: displayOptions.descriptionTextColor
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: displayOptions.shareButtonColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_coinDollar["default"], {
    spaceRight: true
  })), /*#__PURE__*/_react["default"].createElement("strong", null, "Cost: "), /*#__PURE__*/_react["default"].createElement("span", null, "$", resource.product_id && !metadata.cost ? resource.productData.settings.priceListing : metadata.cost)), displayOptions.showDescription && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: displayOptions.descriptionTextColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: resource.published_description || ''
  })));
}
function Tags(_ref2) {
  var resource = _ref2.resource;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: _style["default"].tags
  }, resource.tags && Object.keys(resource.tags).map(function (tag, j) {
    if (Object.keys(resource.tags).length === j + 1) {
      return resource.tags[tag];
    }
    return resource.tags[tag] + ', ';
  }));
}
function ProductActions(_ref3) {
  var resource = _ref3.resource,
    displayOptions = _ref3.displayOptions;
  var hasProductBeenOwned = resource.hasProductBeenOwned;
  var metadata = JSON.parse(resource.published_metadata) || {};
  function PurchaseLink() {
    var btnDataArray = {
      purchase: {
        "class": _style["default"].buttonPurchase,
        icon: _cart["default"],
        label: 'Purchase',
        href: metadata.link || resource.productData.purchaseUrl
      },
      enter: {
        "class": _style["default"].buttonEnter,
        icon: _enter["default"],
        label: 'Enter',
        href: "/product/".concat(resource.productData.handle)
      }
    };
    var btnKey = 'purchase';
    if (hasProductBeenOwned) {
      btnKey = 'enter';
    }
    var btnData = btnDataArray[btnKey];
    var ButtonIcon = btnData.icon;
    if (hasProductBeenOwned) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
        className: "btn ".concat(btnData["class"]),
        to: btnData.href || '#'
      }, btnData.label, /*#__PURE__*/_react["default"].createElement(ButtonIcon, {
        spaceLeft: true
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: "btn ".concat(btnData["class"]),
      href: btnData.href || '#'
    }, btnData.label, /*#__PURE__*/_react["default"].createElement(ButtonIcon, {
      spaceLeft: true
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].productActions
  }, (metadata.learnMore || resource.productData.settings.learnMoreUrl) && /*#__PURE__*/_react["default"].createElement("a", {
    className: "btn ".concat(_style["default"].buttonLearnMore),
    href: metadata.learnMore || resource.productData.settings.learnMoreUrl
  }, "Learn More"), /*#__PURE__*/_react["default"].createElement(PurchaseLink, null), displayOptions.showShareButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonShare
  }, /*#__PURE__*/_react["default"].createElement(_ShareButton["default"], {
    name: resource.published_label,
    url: resource.productData.purchaseUrl,
    displayOptions: displayOptions
  })));
}
function ExternalProductActions(_ref4) {
  var metadata = _ref4.metadata,
    resource = _ref4.resource,
    displayOptions = _ref4.displayOptions,
    externalShareUrl = _ref4.externalShareUrl;
  var btnDataArray = {
    visitWebsite: {
      "class": _style["default"].buttonVisitWebsite,
      icon: _newTab["default"],
      label: 'Visit Website',
      href: metadata.link
    },
    purchase: {
      "class": _style["default"].buttonPurchase,
      icon: _cart["default"],
      label: 'Purchase',
      href: metadata.link
    }
  };
  var btnKey = 'purchase';
  if (metadata.isExternal) {
    btnKey = 'visitWebsite';
  }
  var btnData = btnDataArray[btnKey];
  var ButtonIcon = btnData.icon;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].productActions
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "btn ".concat(btnData["class"]),
    href: btnData.href || '#'
  }, btnData.label, /*#__PURE__*/_react["default"].createElement(ButtonIcon, {
    spaceLeft: true
  })), displayOptions.showShareButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonShare
  }, /*#__PURE__*/_react["default"].createElement(_ShareButton["default"], {
    name: resource.published_label,
    url: externalShareUrl,
    displayOptions: displayOptions
  })));
}
function ProductFooter(_ref5) {
  var resource = _ref5.resource,
    displayOptions = _ref5.displayOptions,
    externalShareUrl = _ref5.externalShareUrl;
  var metadata = JSON.parse(resource.published_metadata) || {};
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12"
  }, displayOptions.showTags && /*#__PURE__*/_react["default"].createElement(Tags, {
    resource: resource
  }))), !resource.product_id ? /*#__PURE__*/_react["default"].createElement(ExternalProductActions, {
    metadata: metadata,
    resource: resource,
    displayOptions: displayOptions,
    externalShareUrl: externalShareUrl
  }) : /*#__PURE__*/_react["default"].createElement(ProductActions, {
    resource: resource,
    displayOptions: displayOptions
  }));
}